import { render, staticRenderFns } from "./commentCashier.vue?vue&type=template&id=23de5b91&scoped=true&"
import script from "./commentCashier.vue?vue&type=script&lang=js&"
export * from "./commentCashier.vue?vue&type=script&lang=js&"
import style0 from "./commentCashier.vue?vue&type=style&index=0&id=23de5b91&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de5b91",
  null
  
)

export default component.exports